export const appConfig = {
  API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_LOCAL_DEV: process.env.REACT_APP_LOCAL_DEV === 'true' ? true : false, // if true then auth token must be sent
  REACT_APP_FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL
};
